import { render, staticRenderFns } from "./CampaignContents.vue?vue&type=template&id=2b522712&"
import script from "./CampaignContents.vue?vue&type=script&lang=js&"
export * from "./CampaignContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports